import { Navigate } from "react-router-dom";

import { useAuth } from "../auth/AuthContext";

export default function LoginPage() {
  const { user, loading, signin, error, reload } = useAuth();
  const loginError = new URLSearchParams(location.search).get("error");
  const messages: Record<string,string> = {
    access_denied: "Доступ не предоставлен. Проверьте права доступа к Recordings.",
    auth_unavailable: "Сервис входа временно недоступен. Попробуйте ещё раз.",
    invalid_login: "Не удалось завершить вход. Начните вход заново.",
    identity_conflict: "Не удалось сопоставить учётную запись. Обратитесь к администратору.",
  };

  if (loading) {
    return (
      <div className="page">
        <p className="muted">Загрузка…</p>
      </div>
    );
  }
  if (user && !new URLSearchParams(location.search).has("logged_out")) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="page login-page">
      <h1>NAN Recordings</h1>
      <p className="muted">Записи звонков. Доступ для сотрудников NAN.</p>
      {error && <p role="alert">{error} <button onClick={() => void reload()}>Повторить проверку</button></p>}
      {loginError && <p role="alert">{messages[loginError] ?? "Не удалось завершить вход."}</p>}
      <button
        type="button"
        className="page-button login-button"
        onClick={() => {
          signin().catch((err) => {
            // eslint-disable-next-line no-console
            console.error("[auth] signin failed", err);
          });
        }}
      >
        Войти через NAN SSO
      </button>
    </div>
  );
}
